const ActionType = Object.freeze({
  ADD: 'Add',
  REMOVE: 'Remove',
  // Activity
  ADDED_ACTIVITY: 'Added activity',
  REMOVED_ACTIVITY: 'Removed activity',
  MOVED_ACTIVITY: 'Moved activity',
  // Activities
  ADD_ACTIVITIES: 'Added activities',
  REMOVE_ACTIVITIES: 'Removed activities',
  MOVE_ACTIVITIES: 'Moved activities',
  UPDATED_HOURS: 'Updated hours',
  UPDATED_ACTIVITY_TAGS: 'Categorised activities',
  // Managers.
  ADD_MANAGERS: 'Added managers',
  ASSIGNED_MANAGERS: 'Assigned managers',
  REMOVE_MANAGERS: 'Removed managers',
  // Properties.
  ADD_PROPERTIES: 'Added properties',
  REMOVE_PROPERTIES: 'Removed properties',
  UPDATE_PROPERTIES: 'Update properties',
  // Role
  ADDED_ROLE: 'New role',
  ASSIGNED_ROLES: 'Assigned roles',
  UPDATED_MANAGER: 'Updated manager',
  REMOVED_ROLE: 'Removed role',
  UPDATED_FTE: 'Updated fte',
  UPDATED_BUDGET: 'Updated budget',
  // Roles
  ADD_ROLES: 'Added roles',
  REMOVE_ROLES: 'Removed roles',
  MOVE_ROLES: 'Moved roles',
  UPDATED_ROLE_TAGS: 'Categorised roles',
  // Tags
  ADD_TAGS: 'Added tags',
  REMOVE_TAGS: 'Removed tags',
  UPDATE_TAGS: 'Update tags',
  // Teams
  ADD_GROUPS: 'Added teams',
  REMOVE_GROUPS: 'Removed teams',
  MOVE_GROUPS: 'Moved teams',
  UPDATED_GROUP_TAGS: 'Categorised teams',
  INCREASED_BUDGET: 'Increased budget',
  INCREASED_HOURS: 'Increased hours',
  INCREASED_FTE: 'Increased fte',
  REDUCED_BUDGET: 'Reduced budget',
  REDUCED_HOURS: 'Reduced hours',
  REDUCED_FTE: 'Reduced fte',
  UPDATE_BUDGETS: 'Updated budgets',
  UPDATE_FTE: 'Updated FTE',
  UPDATE_HOURS: 'Updated Hours',
  UPDATED_TAGS: 'Updated categories',
  UPDATED_SPANS: 'Updated spans',
  // Activity Methodology.
  INCREASE_HOURS: 'Increase hours',
  STOP_ACTIVITIES: 'Stop activities',
  REDUCE_HOURS: 'Reduce hours',
  REALLOCATE_ACTIVITIES: 'Re-allocate activities',
  AUGMENT_ACTIVITIES: 'Augment activities',
  // Role Methodology.
  INCREASE_FTE: 'Increase FTE',
  REMOVE_ROLES: 'Remove roles',
  REDUCE_FTE: 'Reduce FTE',
  REALLOCATE_ROLES: 'Re-allocate roles',
  RESET: 'Reset',
  CUSTOM_EDIT: 'Custom edit',
});

export default ActionType;
